/**
 * Free shipping bar success state.
 * Adds a `free-shipping-bar--reached` class on each <free-shipping-bar> when the threshold is met,
 * so the progress bar can switch to the theme's success color via CSS.
 *
 * The theme's own FreeShippingBar element updates the `total-price` attribute on every `cart:change`
 * (quantity change / new items). We watch that attribute, so the success state re-evaluates automatically.
 * We also watch for bars inserted later (e.g. when the cart drawer re-renders its contents).
 */
(() => {
  const REACHED_CLASS = "free-shipping-bar--reached";

  function sync(bar) {
    const total = parseFloat(bar.getAttribute("total-price"));
    const threshold = parseFloat(bar.getAttribute("threshold"));
    if (Number.isNaN(total) || Number.isNaN(threshold)) return;
    bar.classList.toggle(REACHED_CLASS, total >= threshold);
  }

  function watch(bar) {
    if (bar.__fsSuccessWatched) return;
    bar.__fsSuccessWatched = true;
    sync(bar);
    new MutationObserver(() => sync(bar)).observe(bar, {
      attributes: true,
      attributeFilter: ["total-price", "threshold"],
    });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches("free-shipping-bar")) watch(node);
    if (node.querySelectorAll) node.querySelectorAll("free-shipping-bar").forEach(watch);
  }

  function init() {
    scan(document.body);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(scan));
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
